<template>
  <div class="timetable-week timetable-one-day show-time">
    <div class="timetable-axis">
      <div
        class="axis-item"
        v-for="hour in hours"
        v-bind:style="{ height: rowHeight + 'px' }"
      >
        {{ hour }}:00
      </div>
    </div>
    <div class="timetable-columns">
      <div
        class="timetable-column"
        v-for="(date, di) in dates"
        v-bind:class="{ today: date.isToday }"
        :data-col-index="di"
      >
        <div class="timetable-column-header">
          <div class="timetable-column-header-date">
            {{ date.format("ddd") }}<br />
            <span>{{ date.format("D") }}</span>
          </div>
        </div>
        <div class="timetable-column-content">
          <div
            v-if="isHoverSlotOn(date)"
            class="timetable-drop-placeholder hover-placeholder"
            v-bind:class="{ 'is-picked': hoverSlot.picked }"
            v-bind:style="hoverSlotStyle()"
          ></div>
          <div
            class="timetable-item"
            v-for="event in eventTemplatesByDates[date]"
            v-if="action !== 'show' && showEventTemplate(event, date)"
          >
            <a
              class="timetable-title color-5"
              v-bind:class="{
                disabled: event._start_hour >= blockSchedulingAfterHour,
                compact: isCompactBlock(event._duration_in_hours),
              }"
              @pointerdown="onTemplatePointerDown(event, date, $event)"
              @click.stop.prevent="clickEventTemplate(event, date, $event)"
              v-bind:style="{
                top: rowHeight * (event._offset - calendarStartHour) + 'px',
                height: rowHeight * event._duration_in_hours + 'px',
              }"
            >
              <div class="timetable-title-wrap">
                <div class="timetable-name">
                  {{ eventLabel(event) }}
                </div>
                <div class="timetable-time">
                  {{ event._start_hour }}:{{ event._start_minute | pad }} -
                  {{ event._end_hour }}:{{ event._end_minute | pad }}
                </div>
              </div>
            </a>
          </div>

          <div
            class="timetable-item"
            v-for="event in eventsByDates[date]"
            v-bind:class="event.custom_css_classes"
            v-if="showEvent(event)"
          >
            <a
              class="timetable-title color"
              v-bind:class="{
                'color-1 practice-lesson': event.type === 'practice-lesson',
                'color-2': event.type === 'internal-exam',
                'color-4': event.type === 'theory-lesson',
                'color-0': event.type === 'custom-event',
                'color-3 vacation': isBlockingEvent(event),
                reservation: isReservationEvent(event),
                'is-manageable': isBlockingEvent(event) && canManageVacations,
                selected: isEventHighlighted(event),
                disabled: event.disabled,
                'is-dragging': drag && drag.event === event && drag.started,
                'is-draggable': isDraggableEvent(event),
                compact: !isBlockingEvent(event) && isCompactBlock(event._duration_in_hours),
              }"
              @pointerdown="onEventPointerDown(event, $event)"
              @touchstart="onEventTouchStart(event, $event)"
              @contextmenu="onEventContextMenu(event, $event)"
              :title="eventLabel(event)"
              @click.stop.prevent="onMaybeClick(event, date, $event)"
              v-bind:style="eventBlockStyle(event, date)"
            >
              <button
                v-if="isBlockingEvent(event) && canManageVacations"
                type="button"
                class="vacation-manage-btn"
                :title="texts.vacation_manage || 'Gestionează concediul'"
                @click.stop.prevent="manageVacation(event)"
              >
                <i class="icon-pencil"></i>
              </button>
              <div class="timetable-title-wrap">
                <div
                  class="timetable-name"
                  :style="{ '--tt-name-lines': nameLineClamp(event._duration_in_hours) }"
                >
                  <hero-icon v-if="isReservationEvent(event)" name="lock-closed" class="tt-block-icon"></hero-icon>
                  <hero-icon v-else-if="isBlockingEvent(event)" name="sun" class="tt-block-icon"></hero-icon>
                  {{ eventLabel(event) }}
                </div>
                <div class="timetable-time">
                  {{ event._start_hour }}:{{ event._start_minute | pad }} -
                  {{ event._end_hour }}:{{ event._end_minute | pad }}
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="timetable-column-grid" @mouseleave="leaveGrid">
          <div
            class="grid-item cursor-plus"
            v-for="hour in hours"
            @mousemove="hoverNewEventSlot(date, hour, $event)"
            @pointerdown="onGridPointerDown(date, $event)"
            @click.stop.prevent="addNewEvent(date, hour, $event)"
            v-bind:style="{ height: rowHeight + 'px' }"
          ></div>
        </div>
      </div>
    </div>
    <slot-menu
      v-if="slotMenu"
      :x="slotMenu.x"
      :y="slotMenu.y"
      :label="slotMenuLabel()"
      :texts="texts"
      @pick="pickSlotAction"
      @close="closeSlotMenu"
    ></slot-menu>
  </div>
</template>

<script>
import TimetableViewBase from "./TimetableView-Base.vue";
import { DragRescheduleMixin } from "./mixins/DragRescheduleMixin";
import HeroIcon from "./HeroIcon.vue";

export default {
  extends: TimetableViewBase,
  mixins: [DragRescheduleMixin],
  components: { "hero-icon": HeroIcon },

  props: {
    canManageVacations: {
      default: false,
    },
  },

  data() {
    return {
      view: "day",
    };
  },

  mounted() {
    console.log("Timetable View Day Component Mounted.");
  },
};
</script>
<style lang="scss">
</style>
